module.exports = __webpack_public_path__ + "img/Array_logo.17e0dea0.png";